import { magicNumbers } from 'utils';

export const telegramFiltersInitialState = {
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
      },
      member_count: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:memberCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:resourceBasedOn',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  publishRateFilter: {
    hasFilter: false,
    isOpen: false,
    value: false,
    componentName: 'publishRateFilter',
    translateKey: 'filter:resourceActivity',
  },
};
